import React from 'react';
import { clsx } from 'clsx';

import { Props } from './';

export const IconUser: React.FC<Props> = ({ className, title, ...props }) => (
  <svg
    className={clsx('w-5 h-5', className)}
    fill="currentColor"
    viewBox="0 0 20 20"
    {...(title && { 'aria-labelledby': 'title' })}
    {...props}
  >
    {title && <title id="title">{title}</title>}
    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
  </svg>
);
